import React, { useEffect, useContext, useState, useMemo, useRef } from 'react';
import axios from 'axios';
import { LoginContext } from '../../hooks/context/LoginContext';
import useServerPagination from '../../hooks/useServerPagination';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTableServer from '../../componentes/ui/MiDataTableServer';
import MiSelect from '../../componentes/formulario/MiSelect';
import { Alert } from '../../componentes/ui/Alert';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Informes from '../../componentes/formulario/informes/Informes';
import UplmPlus2 from '../../componentes/formulario/UpmlPlus2/UplmPlus2';

import SupplierReferences from './SupplierReferences';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getTitle, getDecodedCookie, getApiUrl } from '../../helpers/helperApp';

import { Fragment } from 'react';

function Articulos(props) {

    const cookies = new Cookies();

    // ***** Custom Hook - Lógica de los formularios *****
    const { saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo, formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, saveLoadingTable, loadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin, handleEditItem,
        handleNewItem,
        handleSaveItem,
        handleDeleteItem,
        handleCancel,
        alertService
    } = useLogicForm();


    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey } = useContext(LoginContext);

    // ***** State para la configuración de la pantalla *****
    const [confPantalla, saveConfPantalla] = useState(confApp)
    const [loadedConf, saveLoadedConf] = useState(false);
    const [tieneNivel, saveTieneNivel] = useState(true);
    const [estadoFormPrin, saveEstadoFormPrin] = useState("");
    const [estadoFormHijo, saveEstadoFormHijo] = useState("");
    const [activeSaveBtns, saveActiveSaveBtns] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const apiKeyRef = useRef(apiKey);
    const saveLoadingTableRef = useRef(saveLoadingTable);
    apiKeyRef.current = apiKey;
    saveLoadingTableRef.current = saveLoadingTable;

    const paginationOptions = useMemo(() => ({
        apiEndpoint: '/articulos/getArticulos',
        apiKey: apiKeyRef.current,
        setLoadingTableExternal: saveLoadingTableRef.current,
    }), []);


    // ***** Hook de paginación server-side *****
    const {
        data: registrosPrin,
        loadingTable,
        totalPages,
        paginationInfo,
        handlePageChange,
        // handleNextPage,
        // handlePreviousPage,
        handleSearchChange,
        handleDataTableSearch,
        handlePageLengthChange,
        // getPaginationItems,
        resetSearch,
        reload
    } = useServerPagination({ ...paginationOptions, currentPage, setCurrentPage });



    // Estado local para búsqueda (para el input)
    const [searching, setSearching] = useState(false);


    useEffect(() => {

        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then((respuesta) => {
                if (confPantalla === undefined) {
                    return getConfApp();
                } else {
                    document.title = getTitle(confPantalla.config.trad, confPantalla.articulos.title);
                    if (respuesta == 1) {
                        saveEstadoFormPrin(confPantalla.articulos.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.articulos.hijo.estadoForm);
                        saveTieneNivel(true);
                        saveFormularioPrin({ ...confPantalla.articulos.padre.modelform, cod3: confPantalla.articulos.padre.modelform.cod3 || 'no' });
                        saveFormularioHijo(confPantalla.articulos.hijo.modelform);

                        if (props.location.state && (props.location.state.idPrin || props.location.state.idHijo)) {
                            handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.articulos.padre.urls, confPantalla.articulos.hijo.urls, confPantalla.articulos.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);
                        }
                        // ***** Carga inicial de registros *****
                        if (registrosPrin) {
                            if (registrosPrin.length === 0) {
                                saveLoadingTable(true);
                                saveFormularioPrin({ ...confPantalla.articulos.padre.modelform, cod3: confPantalla.articulos.padre.modelform.cod3 || 'no' });
                                saveFormularioHijo(confPantalla.articulos.hijo.modelform);
                            }
                        }
                        // Seleccionar el id que nos llega como parámetro por la url
                        if (props.location.state) {
                            if ("idPrin" in props.location.state || "idHijo" in props.location.state) {
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.articulos.padre.urls, confPantalla.articulos.hijo.urls, confPantalla.articulos.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);
                            }
                        }
                    }
                    else if (respuesta == 0) {
                        saveTieneNivel(false);
                    }
                    saveLoadedConf(true);
                }
            })
            .then((respuesta) => {
                if (respuesta !== undefined) {
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);
                }
            })


    }, [confPantalla])

    // useEffect(() => {
    //     const perPage = 25;
    //     const startRecord = totalRecords > 0 ? (currentPage - 1) * perPage + 1 : 0;
    //     const endRecord = Math.min(currentPage * perPage, totalRecords);

    //     if (totalRecords > 0) {
    //         const sinfoText = confPantalla?.config?.trad?.components?.datatable?.sinfo?.title || "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros";
    //         setPaginationInfo(
    //             sinfoText
    //                 .replace('_START_', startRecord)
    //                 .replace('_END_', endRecord)
    //                 .replace('_TOTAL_', totalRecords)
    //         );
    //     } else {
    //         setPaginationInfo("");
    //     }
    // }, [totalRecords, currentPage, confPantalla])

    useEffect(() => {
        return () => {
            if (socket != null) {
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
            document.querySelector("body").classList.remove("sidebar-open");
        }
    }, [confPantalla])

    // Handler de búsqueda del hook - adaptado para DataTable
    const handleTableSearch = (searchValue) => {
        handleDataTableSearch(searchValue);
    };

    const handleTablePageChange = (newPage) => {
        handlePageChange(newPage);
    };

    const handleCheckRef = async () => {
        if (formularioPrin.cod1 != "") {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("cod1", formularioPrin.cod1)
            const respuesta = await axios.post(`${getApiUrl(window.location.origin)}/articulos/checkRefPublic`, data);
            if (typeof respuesta.data !== "string") {
                if (respuesta.data.length > 0) {
                    saveActiveSaveBtns("false");
                } else {
                    saveActiveSaveBtns("true");
                }
            } if (typeof respuesta.data === "string") {
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, { autoClose: true });
            }
        }
    }


    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const getPaginationItems = (currentPage, totalPages) => {
        const delta = 1; // Número de páginas a cada lado de la actual
        const left = currentPage - delta;
        const right = currentPage + delta + 1;
        const range = [];
        const rangeWithDots = [];
        let l;

        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= left && i < right)) {
                range.push(i);
            }
        }

        for (const i of range) {
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i - l !== 1) {
                    rangeWithDots.push('...');
                }
            }
            rangeWithDots.push(i);
            l = i;
        }

        return rangeWithDots;
    };

    const tableColumns = useMemo(() => {
        const originalColumns = confPantalla?.articulos?.padre?.datatable?.columns;
        if (!originalColumns) {
            return [];
        }

        return originalColumns.map(col => {
            if (col.data === 'cod3') {
                // Cambiamos la fuente de datos para la columna 'Proveedor' a 'cod4'
                return { ...col, data: 'cod4', mData: 'cod4' };
            }
            return col;
        });
    }, [confPantalla]);

    return (
        <div className="App wrapper">
            <div>
                {loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div>
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                        :
                        <Alert />
                }
            </div>
            {
                confPantalla !== undefined
                    ?
                    <Fragment>
                        <Menusup
                            props={props}
                        />
                        <Sidebar
                            props={props}
                        />
                    </Fragment>
                    :
                    null
            }
            <div className="content-wrapper">
                <div className="content-header">
                </div>
                <section className="content">
                    {
                        !tieneNivel
                            ?
                            <PermissionRefused
                                traduction={confPantalla.config.trad.components.permissionrefused}
                            />
                            :
                            <Fragment>
                                {
                                    loadedConf === true && confPantalla !== undefined
                                        ?
                                        <Section titulo={confPantalla.articulos.section.titulo} icono={confPantalla.articulos.section.icono} col={confPantalla.articulos.section.col} idPrin={formularioPrin.id} wiki={confPantalla.articulos.section.wiki} >
                                            <Formulario
                                                estadoForm={estadoFormPrin}
                                                loading={loadReg ? true : false}
                                                btnNew={confPantalla.articulos.padre.btnform.new}
                                                btnSave={activeSaveBtns == "false" ? activeSaveBtns : confPantalla.articulos.padre.btnform.save}
                                                btnSaveAndNew={activeSaveBtns == "false" ? activeSaveBtns : confPantalla.articulos.padre.btnform.saveandnew}
                                                btnDelete={confPantalla.articulos.padre.btnform.delete}
                                                btnClone={confPantalla.articulos.padre.btnform.clone}
                                                handleSubmit={e => handleSubmitPrin(e, confPantalla.articulos.padre.urls, { ...confPantalla.articulos.padre.modelform, cod3: confPantalla.articulos.padre.modelform.cod3 || 'no' }, confPantalla.articulos.padre.tabla, confPantalla.articulos.hijo.modelform, confPantalla.articulos.title)}
                                                formulario={formularioPrin}
                                                resetForm={e => resetFormPrin({ ...confPantalla.articulos.padre.modelform, cod3: confPantalla.articulos.padre.modelform.cod3 || 'no' }, true, confPantalla.articulos.padre.tabla)}
                                                handleDeleteItem={e => handleDeleteItemPrin(undefined, confPantalla.articulos.padre.urls, confPantalla.articulos.padre.modelform, confPantalla.articulos.padre.tabla, confPantalla.articulos.title)}
                                            >
                                                <Informes
                                                    select={confPantalla.articulos.padre.controles.informes.select}
                                                    formulario={formularioPrin}
                                                    loadReg={loadReg ? true : false}
                                                    estadoForm={estadoFormPrin}
                                                    traduction={confPantalla.config.trad.components}
                                                />
                                                <hr className="separator" />
                                                <Tabs defaultActiveKey="tab1" id="tab1">
                                                    <Tab eventKey="tab1" title={confPantalla.articulos.tabs.tab1.titulo}>
                                                        <FormRow clases="" >
                                                            <FormInput
                                                                clasesInput={
                                                                    formularioPrin.cod1 != "" && activeSaveBtns == "false"
                                                                        ? "is-invalid"
                                                                        : formularioPrin.cod1 != "" && activeSaveBtns == "true"
                                                                            ? "is-valid"
                                                                            : ""
                                                                }
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.cod1}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.refprivada.id}
                                                                type={confPantalla.articulos.padre.controles.refprivada.type}
                                                                name={confPantalla.articulos.padre.controles.refprivada.name}
                                                                label={confPantalla.articulos.padre.controles.refprivada.label}
                                                                placeholder={confPantalla.articulos.padre.controles.refprivada.placeholder}
                                                                col={confPantalla.articulos.padre.controles.refprivada.col}
                                                                required={confPantalla.articulos.padre.controles.refprivada.required}
                                                                readonly={confPantalla.articulos.padre.controles.refprivada.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.refprivada.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={handleCheckRef}
                                                            />
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.cod2}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.refpublica.id}
                                                                type={confPantalla.articulos.padre.controles.refpublica.type}
                                                                name={confPantalla.articulos.padre.controles.refpublica.name}
                                                                label={confPantalla.articulos.padre.controles.refpublica.label}
                                                                placeholder={confPantalla.articulos.padre.controles.refpublica.placeholder}
                                                                col={confPantalla.articulos.padre.controles.refpublica.col}
                                                                required={confPantalla.articulos.padre.controles.refpublica.required}
                                                                readonly={confPantalla.articulos.padre.controles.refpublica.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.refpublica.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                            <div className="form-group col-md-2">
                                                                <input type="hidden" name="cod3" value={formularioPrin.cod3 === 'si' ? 'si' : 'no'} />
                                                                <label className="ml-2" style={{marginBottom: "0px"}}>Auditable</label>
                                                                <div className="mb-0 form-group col-md-12">
                                                                    <input
                                                                        id="cod3-toggle"
                                                                        className="apple-switch"
                                                                        type="checkbox"
                                                                        checked={formularioPrin.cod3 == 'si' || formularioPrin.cod3 == '1'}
                                                                        disabled={estadoFormPrin === "disabled" || loadReg}
                                                                        onChange={e => saveFormularioPrin(prev => ({ ...prev, cod3: e.target.checked ? 'si' : 'no' }))}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </FormRow>
                                                        <FormRow clases="" >
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.nom1}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.descripcion1.id}
                                                                type={confPantalla.articulos.padre.controles.descripcion1.type}
                                                                name={confPantalla.articulos.padre.controles.descripcion1.name}
                                                                label={confPantalla.articulos.padre.controles.descripcion1.label}
                                                                placeholder={confPantalla.articulos.padre.controles.descripcion1.placeholder}
                                                                col={confPantalla.articulos.padre.controles.descripcion1.col}
                                                                required={confPantalla.articulos.padre.controles.descripcion1.required}
                                                                readonly={confPantalla.articulos.padre.controles.descripcion1.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.descripcion1.disabled}
                                                                autoComplete={confPantalla.articulos.padre.controles.descripcion1.autocomplete}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.nom2}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.descripcion2.id}
                                                                type={confPantalla.articulos.padre.controles.descripcion2.type}
                                                                name={confPantalla.articulos.padre.controles.descripcion2.name}
                                                                label={confPantalla.articulos.padre.controles.descripcion2.label}
                                                                placeholder={confPantalla.articulos.padre.controles.descripcion2.placeholder}
                                                                col={confPantalla.articulos.padre.controles.descripcion2.col}
                                                                required={confPantalla.articulos.padre.controles.descripcion2.required}
                                                                readonly={confPantalla.articulos.padre.controles.descripcion2.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.descripcion2.disabled}
                                                                autoComplete={confPantalla.articulos.padre.controles.descripcion2.autocomplete}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                        </FormRow>
                                                        <FormRow>
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.num2}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.coste.id}
                                                                type={confPantalla.articulos.padre.controles.coste.type}
                                                                name={confPantalla.articulos.padre.controles.coste.name}
                                                                label={confPantalla.articulos.padre.controles.coste.label}
                                                                placeholder={confPantalla.articulos.padre.controles.coste.placeholder}
                                                                col={confPantalla.articulos.padre.controles.coste.col}
                                                                required={confPantalla.articulos.padre.controles.coste.required}
                                                                readonly={confPantalla.articulos.padre.controles.coste.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.coste.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                            <MiSelect
                                                                estadoForm={estadoFormPrin}
                                                                val={formularioPrin.idtip}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.tipouni.id}
                                                                name={confPantalla.articulos.padre.controles.tipouni.name}
                                                                label={confPantalla.articulos.padre.controles.tipouni.label}
                                                                placeholder={confPantalla.articulos.padre.controles.tipouni.placeholder}
                                                                col={confPantalla.articulos.padre.controles.tipouni.col}
                                                                isClearable={confPantalla.articulos.padre.controles.tipouni.isclearable}
                                                                isSearchable={confPantalla.articulos.padre.controles.tipouni.issearchable}
                                                                dataType={confPantalla.articulos.padre.controles.tipouni.datatype}
                                                                data={confPantalla.articulos.padre.controles.tipouni.data}
                                                                required={confPantalla.articulos.padre.controles.tipouni.required}
                                                                disabled={confPantalla.articulos.padre.controles.tipouni.disabled}
                                                                readOnly={confPantalla.articulos.padre.controles.tipouni.readonly}
                                                                disablethisid={confPantalla.articulos.padre.controles.tipouni.disablethisid}
                                                                formulario={formularioPrin}
                                                                change={handleSelectFormPrin}
                                                            />
                                                        </FormRow>
                                                        <FormRow>
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.fec1}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.fecemi.id}
                                                                type={confPantalla.articulos.padre.controles.fecemi.type}
                                                                name={confPantalla.articulos.padre.controles.fecemi.name}
                                                                label={confPantalla.articulos.padre.controles.fecemi.label}
                                                                placeholder={confPantalla.articulos.padre.controles.fecemi.placeholder}
                                                                col={confPantalla.articulos.padre.controles.fecemi.col}
                                                                required={confPantalla.articulos.padre.controles.fecemi.required}
                                                                readonly={confPantalla.articulos.padre.controles.fecemi.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.fecemi.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.fec2}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.feccad.id}
                                                                type={confPantalla.articulos.padre.controles.feccad.type}
                                                                name={confPantalla.articulos.padre.controles.feccad.name}
                                                                label={confPantalla.articulos.padre.controles.feccad.label}
                                                                placeholder={confPantalla.articulos.padre.controles.feccad.placeholder}
                                                                col={confPantalla.articulos.padre.controles.feccad.col}
                                                                required={confPantalla.articulos.padre.controles.feccad.required}
                                                                readonly={confPantalla.articulos.padre.controles.feccad.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.feccad.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.num3}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.stomin.id}
                                                                type={confPantalla.articulos.padre.controles.stomin.type}
                                                                name={confPantalla.articulos.padre.controles.stomin.name}
                                                                label={confPantalla.articulos.padre.controles.stomin.label}
                                                                placeholder={confPantalla.articulos.padre.controles.stomin.placeholder}
                                                                col={confPantalla.articulos.padre.controles.stomin.col}
                                                                required={confPantalla.articulos.padre.controles.stomin.required}
                                                                readonly={confPantalla.articulos.padre.controles.stomin.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.stomin.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                            <FormInput
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.num1}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.stoact.id}
                                                                type={confPantalla.articulos.padre.controles.stoact.type}
                                                                name={confPantalla.articulos.padre.controles.stoact.name}
                                                                label={confPantalla.articulos.padre.controles.stoact.label}
                                                                placeholder={confPantalla.articulos.padre.controles.stoact.placeholder}
                                                                col={confPantalla.articulos.padre.controles.stoact.col}
                                                                required={confPantalla.articulos.padre.controles.stoact.required}
                                                                readonly={confPantalla.articulos.padre.controles.stoact.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.stoact.disabled}
                                                                linkRight={confPantalla.articulos.padre.controles.stoact.linkright + "/" + formularioPrin.id}
                                                                linkColor={confPantalla.articulos.padre.controles.stoact.linkcolor}
                                                                linkIco={confPantalla.articulos.padre.controles.stoact.linkico}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                        </FormRow>
                                                        <FormRow>
                                                            <MiSelect
                                                                estadoForm={estadoFormPrin}
                                                                val={formularioPrin.idapa}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.idapa.id}
                                                                name={confPantalla.articulos.padre.controles.idapa.name}
                                                                label={confPantalla.articulos.padre.controles.idapa.label}
                                                                placeholder={confPantalla.articulos.padre.controles.idapa.placeholder}
                                                                col={confPantalla.articulos.padre.controles.idapa.col}
                                                                isClearable={confPantalla.articulos.padre.controles.idapa.isclearable}
                                                                isSearchable={confPantalla.articulos.padre.controles.idapa.issearchable}
                                                                dataType={confPantalla.articulos.padre.controles.idapa.datatype}
                                                                data={confPantalla.articulos.padre.controles.idapa.data}
                                                                required={confPantalla.articulos.padre.controles.idapa.required}
                                                                disabled={confPantalla.articulos.padre.controles.idapa.disabled}
                                                                readOnly={confPantalla.articulos.padre.controles.idapa.readonly}
                                                                disablethisid={confPantalla.articulos.padre.controles.idapa.disablethisid}
                                                                formulario={formularioPrin}
                                                                change={handleSelectFormPrin}
                                                            />
                                                        </FormRow>
                                                    </Tab>
                                                    <Tab eventKey="tab2" title={confPantalla.articulos.tabs.tab2.titulo}>
                                                        <FormRow>
                                                            <TextArea
                                                                estadoForm={estadoFormPrin}
                                                                value={formularioPrin.notas}
                                                                loading={loadReg ? true : false}
                                                                id={confPantalla.articulos.padre.controles.notas.id}
                                                                name={confPantalla.articulos.padre.controles.notas.name}
                                                                rows={confPantalla.articulos.padre.controles.notas.rows}
                                                                label={confPantalla.articulos.padre.controles.notas.label}
                                                                placeholder={confPantalla.articulos.padre.controles.notas.placeholder}
                                                                col={confPantalla.articulos.padre.controles.notas.col}
                                                                required={confPantalla.articulos.padre.controles.notas.required}
                                                                readonly={confPantalla.articulos.padre.controles.notas.readonly}
                                                                disabled={confPantalla.articulos.padre.controles.notas.disabled}
                                                                change={e => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                                onBlur={null}
                                                            />
                                                        </FormRow>
                                                    </Tab>
                                                    <Tab eventKey="tab3" title={confPantalla.articulos.tabs.tab3.titulo}>
                                                        <FormRow clases="" >
                                                            {/* <Uplm
                                                            estadoForm= { estadoFormPrin }
                                                            loading=    { loadReg ? true : false }
                                                            col={12}
                                                            id={ confPantalla.articulos.padre.controles.uplm.id }
                                                            adjuntos={ adjuntosPrin }
                                                            saveAdjuntos= { saveAdjuntosPrin }  
                                                            adjuntosExistentes= { adjuntosExistentesPrin } 
                                                            saveAdjuntosExistentes= { saveAdjuntosExistentesPrin }
                                                            readonly={ confPantalla.articulos.padre.controles.uplm.readonly }
                                                            traduction={confPantalla.config.trad.components.uplm}
                                                        /> */}
                                                            <UplmPlus2
                                                                id={confPantalla.articulos.padre.controles.uplmplus.id}
                                                                adjuntos={adjuntosPrin}
                                                                saveAdjuntos={saveAdjuntosPrin}
                                                                adjuntosExistentes={adjuntosExistentesPrin}
                                                                saveAdjuntosExistentes={saveAdjuntosExistentesPrin}
                                                                estadoForm={estadoFormPrin}
                                                                loading={loadReg ? true : false}
                                                                col={12}
                                                                readonly={confPantalla.articulos.padre.controles.uplmplus.readonly}
                                                                traduction={confPantalla.config.trad.components}
                                                                datatable={confPantalla.articulos.padre.controles.uplmplus.datatable}
                                                                select={confPantalla.articulos.padre.controles.uplmplus.select}
                                                            />
                                                        </FormRow>
                                                    </Tab>
                                                    <Tab eventKey="tab4" title="Referencias proveedor">
                                                        <SupplierReferences onUpdate={reload} articleName={formularioPrin.cod1} articleId={formularioPrin.id} onBlur={null}></SupplierReferences>
                                                    </Tab>
                                                    {/* <Tab eventKey="tab4" title={ confPantalla.articulos.tabs.tab4.titulo }>
                                                    <Informes
                                                        select =     { confPantalla.articulos.padre.controles.informes.select }
                                                        formulario = { formularioPrin }
                                                        loadReg =    { loadReg ? true : false }
                                                        estadoForm=  { estadoFormPrin } 
                                                        traduction=  { confPantalla.config.trad.components }
                                                    /> 
                                                </Tab>*/}
                                                </Tabs>

                                            </Formulario>
                                            <MiDataTableServer
                                                formulario={formularioPrin}
                                                estadoForm={estadoFormPrin}
                                                lastSelectedId={formularioPrin.id}
                                                id={"articulos"}
                                                columnas={tableColumns}
                                                data={registrosPrin}
                                                buttons={confPantalla.articulos.padre.datatable.buttons}
                                                ordering={confPantalla.articulos.padre.datatable.ordering}
                                                order={confPantalla.articulos.padre.datatable.order}
                                                searching={confPantalla.articulos.padre.datatable.searching}
                                                paging={false}
                                                select={confPantalla.articulos.padre.datatable.select}
                                                pagelength={confPantalla.articulos.padre.datatable.pagelength}
                                                handleEditReg={e => handleEditRegPrin(e, confPantalla.articulos.padre.urls, confPantalla.articulos.hijo.urls, confPantalla.articulos.padreshijos, confPantalla.articulos.hijo.modelform, confPantalla.articulos.padre.tabla)}
                                                handleDeleteItem={e => handleDeleteItemPrin(e, confPantalla.articulos.padre.urls, confPantalla.articulos.padre.modelform, confPantalla.articulos.padre.tabla, confPantalla.articulos.title)}
                                                saveLoadingTable={saveLoadingTable}
                                                loadingTable={loadingTable}
                                                columnactions={confPantalla.articulos.padre.datatable.columnactions.title}
                                                paginationInfo={paginationInfo}
                                                searchBackend={true}
                                                onSearchChange={handleDataTableSearch}
                                                onPageLengthChange={handlePageLengthChange}
                                                exportExcelUrl={`${getApiUrl(window.location.origin)}/articulos/exportExcel`}
                                                exportPdfUrl={`${getApiUrl(window.location.origin)}/articulos/exportPdf`}
                                                traduction={{
                                                    sprocessing: { title: "Procesando..." },
                                                    slengthmenu: { title: "Mostrar _MENU_ registros" },
                                                    szerorecords: { title: "No se encontraron resultados" },
                                                    semptytable: { title: "Ningún dato disponible en esta tabla" },
                                                    sinfo: { title: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros" },
                                                    sinfoempty: { title: "Mostrando registros del 0 al 0 de un total de 0 registros" },
                                                    sinfofiltered: { title: "(filtrado de un total de _MAX_ registros)" },
                                                    sinfopostfix: { title: "" },
                                                    ssearch: { title: "Buscar:" },
                                                    surl: { title: "" },
                                                    sinfothousands: { title: "," },
                                                    sloadingrecords: { title: "Cargando..." },
                                                    sfirst: { title: "Primero" },
                                                    slast: { title: "Último" },
                                                    snext: { title: "Siguiente" },
                                                    sprevious: { title: "Anterior" },
                                                    ssortascending: { title: ": Activar para ordenar la columna de manera ascendente" },
                                                    ssortdescending: { title: ": Activar para ordenar la columna de manera descendente" },
                                                    rows: { title: '%d filas seleccionadas' },
                                                    copytitle: { title: 'Copiar al portapapeles' },
                                                    copykeys: { title: 'Use Ctrf+C para copiar los datos de la tabla a su portapapeles.' },
                                                    copysuccess: {
                                                        many: { title: 'Copiadas %d filas al portapapeles' },
                                                        one: { title: 'Copiada 1 fila al portapapeles' }
                                                    },
                                                }}
                                            />

                                            <div className="d-flex justify-content-end align-items-center mt-3">
                                                <div className="dataTables_info" style={{ paddingRight: '15px' }}>
                                                    {/* {paginationInfo} */}
                                                </div>
                                                <div className="dataTables_paginate paging_simple_numbers">
                                                    <ul className="pagination" style={{ marginBottom: 0 }}>
                                                        <li className={`paginate_button page-item previous ${currentPage === 1 || searching ? 'disabled' : ''}`} id="articulos_previous">
                                                            <a href="#" aria-controls="articulos" role="link" data-dt-idx="previous" tabIndex="-1" className="page-link" onClick={(e) => { e.preventDefault(); if (currentPage > 1 && !searching) handlePreviousPage(); }}>
                                                                {confPantalla.config.trad.components.datatable.sprevious.title}
                                                            </a>
                                                        </li>
                                                        {totalPages > 1 && getPaginationItems(currentPage, totalPages).map((item, index) => {
                                                            if (item === '...') {
                                                                return (
                                                                    <li key={index} className="paginate_button page-item disabled">
                                                                        <span className="page-link">...</span>
                                                                    </li>
                                                                );
                                                            }
                                                            return (
                                                                <li key={index} className={`paginate_button page-item ${item === currentPage ? 'active' : ''}`}>
                                                                    <a href="#" aria-controls="articulos" role="link" className="page-link" onClick={(e) => { e.preventDefault(); handlePageChange(item); }}>
                                                                        {item}
                                                                    </a>
                                                                </li>
                                                            );
                                                        })}
                                                        <li className={`paginate_button page-item next ${currentPage === totalPages || searching ? 'disabled' : ''}`} id="articulos_next">
                                                            <a href="#" aria-controls="articulos" role="link" data-dt-idx="next" tabIndex="0" className="page-link" onClick={(e) => { e.preventDefault(); if (currentPage < totalPages && !searching) handleNextPage(); }}>
                                                                {confPantalla.config.trad.components.datatable.snext.title}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Section>
                                        :
                                        <LoadingPage />
                                }
                            </Fragment>
                    }

                </section>
            </div>
            <Footer />
        </div>

    );

}
export default Articulos